<template>
    <div class="main">
        <Header />
        <AsideNav />
        <router-view />
    </div>
</template>

<script>
import Header from "../components/header.vue";
import AsideNav from "../components/asideNav.vue";
export default {
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    components: {
        Header,
        AsideNav,
    },
    watch: {},
};
</script>

<style lang="scss">
.main {
    position: relative;
    padding-left: 300px;
    padding-top: 80px;
    min-height: 100vh;
    background: #f6f6f6;
    overflow: hidden;
}
.container {
    min-height: calc(100vh - 80px - 20px);
    background: #ffffff;
    margin: 20px 20px 0px 20px;
    position: relative;
    padding: 30px 80px 0px 30px;
}
.conList_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    background: #cbd0d6;
    & > div {
        flex: 1;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .operation {
        flex: 0 0 130px;
        a {
            color: #ff8914;
            cursor: pointer;
            padding: 10px;
            &:hover {
                transform: scale(1.15);
            }
        }
        span {
            color: #ff8914;
        }
    }
}
.conList_items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    &:nth-of-type(2n) {
        background: #f7f7f7;
    }
    & > div {
        flex: 1;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 1.5;
    }
    .operation {
        flex: 0 0 130px;
        a {
            color: #ff8914;
            cursor: pointer;
            padding: 10px;
            &:hover {
                transform: scale(1.15);
            }
        }
        span {
            color: #ff8914;
        }
    }
}
.breadcrumb {
    color: #808080;
    font-size: 18px;
    padding-bottom: 15px;
    a {
        cursor: pointer;
        color: #000;
        &:hover {
            color: red;
        }
    }
    i {
        color: #000;
        margin: 0 4px;
    }
}
.header {
    display: flex;
    align-items: center;
    position: relative;
    padding-bottom: 20px;
}
.btn_primary {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    height: 32px;
    width: 120px;
    background: #ff8914;
    color: #fff;
    cursor: pointer;
    user-select: none;
    border: none;
    outline: none;
    &:hover {
        background: rgba($color: #ff8914, $alpha: 0.85);
    }
    &:active {
        background: #ff7f00;
    }
}

.form {
    width: 900px;
    .formItem {
        display: flex;
        align-items: center;
        min-height: 50px;
        padding: 10px 0;
        & > div:first-child {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 120px;
            padding-right: 20px;
            i {
                color: red;
                font-size: 16px;
                padding-right: 5px;
                padding-top: 5px;
            }
        }
    }
    .formBtns {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 80px;
        button {
            margin: 0 40px;
            font-size: 18px;
        }
    }
}

.checkBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
    }
    input[type="checkbox"] {
        cursor: pointer;
        width: 16px;
        height: 16px;
        background-color: #fff;
        -webkit-appearance: none;
        border: 1px solid #c9c9c9;
        outline: none;
        &:checked {
            border: none;
            background: url("../assets/img/choose_on.png") no-repeat center;
            background-size: 100%;
        }
    }
}

@media only screen and (max-width: 1700px) {
    .main {
        padding-left: 16%;
    }
}
@media only screen and (max-width: 1500px) {
    .container {
        padding-right: 30px;
    }
}
</style>
